<template>
  <div id="eventcard-wrapper">
    <transition-group name="el-fade-in" mode="out-in" style="display:contents;">
      <template v-if="skeleton">
        <el-skeleton :loading="true" class="eventcard-block" animated v-for="i in 6" :key="i">
          <template slot="template">
            <div class="event-skeleton" :key="i + '-skeleton-key'">
              <div class="event-skeleton-header">
                <el-skeleton-item variant="image" style="aspect-ratio:11.2/5;width:100%;height:auto;" />
              </div>
              <div class="event-skeleton-body">
                <div class="event-skeleton-logo">
                  <el-skeleton-item variant="image" style="width:64px;height:64px;border-radius:1rem;" />
                </div>

                <el-skeleton-item variant="text" style="margin-right: 16px; height:24px;" />
                <div class="text-wrapper">
                  <el-skeleton-item variant="text" style="width: 18px;height:18px;margin-top:1rem;" />
                  <el-skeleton-item variant="text" style="width: 50%; height:18px;" />
                </div>
                <div class="text-wrapper">
                  <el-skeleton-item variant="text" style="width: 18px;height:18px;margin-top:.5rem;" />
                  <el-skeleton-item variant="text" style="width: 50%; height:18px;" />
                </div>
                <div class="text-wrapper">
                  <el-skeleton-item variant="text" style="width: 18px;height:18px;margin-top:.5rem;" />
                  <el-skeleton-item variant="text" style="width: 50%; height:18px;" />
                </div>
              </div>
            </div>
            <div style="padding: 14px;"></div>
          </template>
        </el-skeleton>
      </template>

      <div class="eventcard-block" v-else v-for="item in data" :key="item.id">
        <div class="eventcard">
          <div class="event-type" v-if="item.type != 1" :class="{ danger: item.type != 0 && item.type != 1 }">
            <i class="fas fa-video"></i>
            <span>{{ getEnumsDisplay("EventType", item.type) }}</span>
          </div>
          <div class="eventcard-header" @click="$store.dispatch('getEventBySlug', { id: item.id, slug: item.slug, route: true })">
            <img class="eventcard-cover" :src="$imageus + (item.image == null ? host + '/static/1120x500.png' : item.image) + '?width=560&height=250&mode=cover'" alt="" />
          </div>

          <div class="eventcard-card">
            <div class="eventcard-logo">
              <div class="logo" :style="'background-image: url(' + $imageus + (item.logo == null ? host + '/static/500x500.png' : item.logo) + '?width=150&height=150&mode=cover)'" @click="$store.dispatch('getEvent', { id: item.id, route: true })"></div>

              <div class="category">
                <span v-if="item.category != null">{{ item.category }}</span>
              </div>
            </div>
            <div class="eventcard-bookmark">
              <a :href="'https://www.google.com/calendar/event?action=TEMPLATE&text=' + item.title + '&dates=' + moment(item.startDate).format('YYYYMMDDTHHMM') + '/' + moment(item.endDate).format('YYYYMMDDTHHMM') + '&details=For+details,+go+here:%0Ahttps://live.holacon.com/' + '&location=' + item.location.venue + ',+' + item.location.address + '&trp=false&sprop=&sprop=name:'" target="_blank" rel="nofollow">
                <i class="fa fa-bookmark"></i>
              </a>
            </div>

            <div class="event-title" @click="$store.dispatch('getEventBySlug', { id: item.id, slug: item.slug, route: true })">
              <h1>{{ item.title }}</h1>

              <div class="event-dates-container">
                <div class="event-date">
                  <div class="date-icon-box">
                    <i class="fas fa-calendar"></i>
                  </div>
                  <span
                    >{{
                      moment(item.startDate)
                        .utc()
                        .format("DD MMMM")
                    }}
                  </span>
                  <i class="fas fa-long-arrow-alt-right"></i>
                  <span
                    >{{
                      moment(item.endDate)
                        .utc()
                        .format("DD MMMM, YYYY")
                    }}
                  </span>
                </div>
                <div class="event-date">
                  <div class="date-icon-box">
                    <i class="fas fa-clock"></i>
                  </div>
                  <span>{{ item.startTime }} </span>
                  <i class="fas fa-long-arrow-alt-right"></i>
                  <span>{{ item.endTime }} </span>
                  <span class="timezone">( {{ item.timezone }} )</span>
                </div>
                <div class="event-date" v-if="item.location.venue != null && item.location.venue != ''">
                  <div class="date-icon-box">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                  <span v-if="item.location.venue != null && item.location.venue != ''">
                    {{ item.location.venue }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
export default {
  name: "EventBlock",
  props: ["data", "skeleton"],
  data() {
    return {
      moment,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host
    };
  }
};
</script>

<style lang="less">
#eventcard-wrapper {
  display: contents;
  .eventcard-block {
    width: 100%;
    .event-skeleton {
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 1rem;
      overflow: hidden;
      .event-skeleton-body {
        padding: 10px;
        padding-top: 42px;
        position: relative;
        .event-skeleton-logo {
          position: absolute;
          box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
          border-radius: 1rem;
          top: -32px;
          left: 1rem;
        }
      }
    }

    .eventcard {
      position: relative;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 1rem;
      overflow: hidden;
      background: #ffffff;
      .event-type {
        padding: 4px 8px;
        height: 32px;
        min-width: 77px;
        position: absolute;
        right: 10px;
        top: 10px;
        background: #50bfbf;
        border: 2px solid #e8ebef;
        border-radius: 32px;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        z-index: 2;
        i {
          font-size: 16px;
        }
        display: flex;
        align-items: center;
        gap: 4px;
        &.danger {
          background: #ff6565;
        }
      }
      h4,
      h5 {
        margin: 0;
      }

      .eventcard-header {
        width: 100%;
        position: relative;
        cursor: pointer;

        .eventcard-cover {
          width: 100%;
          aspect-ratio: 11.2/5;
          height: auto;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
          box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
        }
      }

      .eventcard-card {
        display: block;
        background-color: #fff;
        position: relative;
        padding: 8px 10px;
        // border: 0.5px solid #D6D9D9;

        .eventcard-bookmark {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;

          a {
            border: none;
            outline: none;
            background-color: transparent;
            font-weight: bold;
            cursor: pointer;
            font-size: 20px;
            pointer-events: all;

            i {
              color: #8c929c;
            }
          }
        }
        .eventcard-logo {
          display: flex;
          flex-direction: row;
          align-items: flex-end;
          justify-content: space-between;
          margin-top: -46px;
          position: relative;
          pointer-events: none;

          .logo {
            border-radius: 16px;
            background-color: #fff;
            background-size: cover;
            background-position: 50%;
            width: 64px;
            height: 64px;
            background-repeat: no-repeat;
            border: 3px solid #ffffff;
            box-shadow: 0px 2px 8px rgba(41, 47, 59, 0.24);
            cursor: pointer;
            pointer-events: all;
          }

          .category {
            width: calc(~"100% - 100px");
            margin-left: 10px;
            display: flex;

            span {
              color: #505763;
              font-size: 13px;
              font-weight: 500;
              align-items: center;
              justify-content: flex-start;
              flex-direction: row;
              display: flex !important;
              margin-top: 3px;

              &:not:first-child {
                margin-left: 6px;
              }

              i {
                background-position: 50%;
                background-repeat: no-repeat;
                background-size: contain;
                width: 13px;
                height: 13px;
                margin: 0;
                padding: 0;
                cursor: pointer;
                margin-right: 6px;
              }
            }
          }
        }

        .event-title {
          margin-top: 10px;
          margin-bottom: 10px;
          color: #292f3b !important;
          display: flex;
          flex: 1;
          gap: 1rem;
          flex-direction: column;
          cursor: pointer;

          & > .event-dates-container {
            display: flex;
            flex-direction: column;
            gap: 8px;
            & > .event-date {
              display: flex;
              align-items: center;
              gap: 6px;
              .timezone {
                font-weight: 400;
                font-size: 12px;
                line-height: 18px;
                color: #268ea6;
              }

              align-items: center;
              & > .date-icon-box {
                background: #f1f3f6;
                display: flex;
                flex-shrink: 0;
                color: #268ea6;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                width: 24px;
                height: 24px;
                font-size: 14px;
              }
              & > span {
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
              }
              & > i {
                color: #505763;
                font-size: 18px !important;
                flex-shrink: 0;
              }
            }
          }

          h1 {
            margin: 0;
            font-weight: 700;
            font-size: 16px;
            color: #292f3b !important;
            letter-spacing: -0.015em;
            line-height: 1.5385;
          }
          @media screen and (max-width: 375px) {
            span {
              max-width: 240px;
            }
          }

          span {
            color: #505763;
            font-size: 13px;
            font-weight: 500;
            align-items: center;
            justify-content: flex-start;
            flex-direction: row;
            display: flex !important;
            margin-top: 3px;

            i {
              background-position: 50%;
              background-repeat: no-repeat;
              background-size: contain;
              width: 13px;
              height: 13px;
              margin: 0;
              padding: 0;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/modules/EventBlock.vue